'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './chart-of-accounts.routes';

export class ChartOfAccountComponent {

  constructor(AccountingService, SettingsService) {
    'ngInject';

    this.asTable = false;

    this.treeOptions = {
      nodeChildren: "subAccounts",
      dirSelectable: true,
      injectClasses: {
        ul: "a1",
        li: "a2",
        liSelected: "a7",
        iExpanded: "a3",
        iCollapsed: "a4",
        iLeaf: "a5",
        label: "a6",
        labelSelected: "a8"
      }
    };

    this.showSelected = (node) => {
      console.log(node);
    };

    this.AccountingService = AccountingService;
    this.SettingsService = SettingsService;

    this.flattedAccounts = [];

    this.SettingsService.getByName({name: 'chart-of-accounts'}, coa => {
      this.data = coa.data;

      this.data.forEach(headAccount => {
        this.flattedAccounts.push({
          account: headAccount.account,
          code: headAccount.code,
          description: headAccount.description
        });

        if (headAccount.hasOwnProperty('subAccounts')) {

          headAccount.subAccounts.forEach(subAccount => {

            this.flattedAccounts.push({
              account: [headAccount.account, subAccount.account].join(' / '),
              code: subAccount.code,
              description: subAccount.description
            });

            if (subAccount.hasOwnProperty('subAccounts')) {

              subAccount.subAccounts.forEach(subSubAccount => {

                this.flattedAccounts.push({
                  account: [headAccount.account, subAccount.account, subSubAccount.account].join(' / '),
                  code: subSubAccount.code,
                  description: subSubAccount.description
                });

              });

            }

          });

        }
      })

    });
  }

  setAsTable(val) {
    this.asTable = val;
  }

}

export default angular.module('conduuApp.chartOfAccounts', [uiRouter])
  .config(routes)
  .component('chartOfAccounts', {
    template: require('./chart-of-accounts.html'),
    controller: ChartOfAccountComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/accounting/chart-of-accounts/chart-of-accounts.component.js